export const ENDPOINT = "https://api.ingloba.pt";
//export const ENDPOINT = "http://localhost:8083";